import { useTranslation } from 'react-i18next';

export const LoadingIndicator = () => {
  const { t } = useTranslation();
  return <div>{t('common.loading')}</div>;
};
